import React from 'react'
import ProgressGraphic from './ProgressGraphic'
import { formatSteps, formatCurrency } from '../utils';

const ProgressBar = ({amount, type, target}) => {
    const isFundraisingType = type.includes('Fundraising')
    const lightBlue = '#0575E0'
    const darkBlue = '#111478'
    const percentage = amount / target * 100

    const formattedAmount = isFundraisingType ? formatCurrency({
        amount,
        currencyCode: 'GBP',
        locale: 'gb'
      }) : formatSteps(amount)
    
    const formattedTarget = isFundraisingType ? formatCurrency({
        amount: target,
        currencyCode: 'GBP',
        locale: 'gb'
      }) : formatSteps(target)

return ( 
    <div
        className={isFundraisingType ? 'fundraisingContainer' : 'fitnessContainer'}
    >
    <h2 className='heading'>
    {isFundraisingType ? 'Fundraising' : 'Steps'}
    </h2>

    <ProgressGraphic
        fillColor={isFundraisingType ? lightBlue : darkBlue}
        percentage={percentage}
    />

    <div className='metrics'>
    <div>
        {isFundraisingType ? 'Raised: ' : 'Steps: '}
        <span className='amount'>
        {formattedAmount}
        </span>
    </div>
    <div>
        Target:{' '}
        <span className='amount'>
        {formattedTarget}
        </span>
    </div>
    </div>
    </div> 
)
}

export default ProgressBar